module.exports = __webpack_public_path__ + "assets/img/unfold.40f5c618.svg";